import { Lightning } from 'react-bytesize-icons';
import livereload from "../../../../assets/images/docs/livereload/livereload.png";
import autoreload from "../../../../assets/images/docs/livereload/autoreload.png";
import * as React from 'react';
export default {
  Lightning,
  livereload,
  autoreload,
  React
};